<template>
  <div class="result-game-lto t-text">
    <h2>{{ $t('resultView.gameLoadTimeOut.headline') }}</h2>
    <i class="icf-alert alert-icon" />
    <p class="details">{{ $t('resultView.gameLoadTimeOut.details') }}</p>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
.result-game-lto {
  margin: 0 auto;
  padding: 2em 3em 0.5em;
  max-width: 34em;
  text-align: center;

  .alert-icon {
    font-size: 3em;
    display: inline-block;
    border-radius: 100%;
    border: 5px solid @c1-g;
    padding: 0;
    width: 5.125rem;
    height: 5.125rem;
    color: @c1-g;
    margin: 0 0.2em;
  }

  .details {
    font-size: 1em;
  }
}
</style>
